
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 15.875 15.875","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M60.872 1.983v.603","fill":"none"}}),_c('path',{attrs:{"d":"M7.937.884a4.213 4.213 0 10.001 8.427A4.213 4.213 0 007.937.884zm0 .26a3.953 3.953 0 110 7.907 3.953 3.953 0 010-7.907z","clip-rule":"evenodd","fill":"none","stroke":"#f5f5f5","stroke-width":".573","stroke-miterlimit":"10"}}),_c('path',{attrs:{"clip-rule":"evenodd","fill":"#f5f5f5","fill-rule":"evenodd","d":"M7.41 2.622h1.054V5.96H7.41zM7.41 6.575h1.054v1.01H7.41z"}}),_c('path',{attrs:{"d":"M12.552 15.277l-3.798-2.5 3.798-2.5z","opacity":".99","fill":"#f5f5f5"}}),_c('path',{attrs:{"opacity":".99","fill":"#f5f5f5","d":"M12.531 11.575h3.056v2.405h-3.056zM3.323 15.277l3.798-2.5-3.798-2.5z"}}),_c('path',{attrs:{"opacity":".99","fill":"#f5f5f5","d":"M3.344 11.575H.288v2.405h3.056zM7.485 10.74h.905v4.075h-.905z"}})])
          )
        }
      }
    